// moz667: por culpa de vrdemo
var $ = jQuery;

window.alertDialog = (function ($) {
    'use strict';

	// Creating modal dialog's DOM
	var $dialog = $(
		'<div id="alertDialog" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true" style="padding-top:15%; overflow-y:visible;">' +
		'<div class="modal-dialog">' +
		'<div class="modal-content">' +
			'<div class="modal-header">' +
                '<h5 class="modal-title" id="alertDialogLabel">Titulo</h5>' +
                '<button type="button" class="close" data-dismiss="modal" aria-label="' + n2m_i18n("Cerrar") + '"><span aria-hidden="true">&times;</span></button>' +
            '</div>' +
			'<div class="modal-body"><p>Mensaje</p></div>' +
            '<div class="modal-footer">' +
                '<button type="button" class="btn btn-secondary" data-dismiss="modal">' + n2m_i18n("Cerrar") + '</button>' +
            '</div>' +
		'</div></div></div>');

	// Desde la version alpha-6 de bootstrap tenemos que meter
	// este switch para verificar que se termino la transicion
	// antes de ocultar el modal. Si no, da error.
	var finish_transitions = false;

	return {
		/**
		 * Opens our dialog
		 * @param options Custom options:
		 * 				  options.dialogSize - bootstrap postfix for dialog size, e.g. "sm", "m";
		 * 				  options.progressType - bootstrap postfix for progress bar type, e.g. "success", "warning".
		 */
		show: function (options) {
            // console.log("SHOW INI!!!");
			// Assigning defaults
			if (typeof options === 'undefined') {
				options = {};
			}

			var settings = $.extend({
                title: 'Titulo',
				message: '<p>Mensaje</p>',
				dialogSize: 'm',
				onHide: null, // This callback runs after the dialog was hidden
				onShow: null
			}, options);

			// Configuring dialog
			$dialog.find('.modal-dialog').attr('class', 'modal-dialog').addClass('modal-' + settings.dialogSize);
			$dialog.find('.progress-bar').attr('class', 'progress-bar');

			if (settings.progressType) {
				$dialog.find('.progress-bar').addClass('progress-bar-' + settings.progressType);
			}

			$dialog.find('h5').text(settings.title);
            $dialog.find('.modal-body').html(settings.message);

			// Adding callbacks
			if (typeof settings.onHide === 'function') {
				$dialog.off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
					settings.onHide.call($dialog);
				});
			}

			$dialog.off('shown.bs.modal').on('shown.bs.modal', function (e) {
				finish_transitions = true;
				
				// TODO: Hacer de otra forma para que no sea una coia de audit-click.js
				$dialog.find(".audit-click").each(function () {
					if (N2M.AUDIT_CLICK_URL) {
						var $link = $(this);
				
						$link.on("click", function (e) {
							var extra_click_info = $link.data('extra');
				
							if (extra_click_info) {
								var current_page = $link.attr("href");
								audit_click(current_page, extra_click_info);
				
							}
						});
					}
				});

				if (typeof settings.onShow === 'function') {
					settings.onShow.call($dialog);
				}
			});

			// Opening dialog
			$dialog.modal('show');
            // console.log("SHOW FIN!!!");
		},
		/**
		 * Closes dialog
		 */
		hide: function (callback) {
            // console.log("HIDE INI!!!");
			var hide_interval_id = setInterval(_try_hide, 100);

			function _try_hide() {
				// console.log("_try_hide");
				if (finish_transitions) {
					finish_transitions = false;
					clearInterval(hide_interval_id);

					if (typeof callback === 'function') {
						$dialog.off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
							$dialog.off('hidden.bs.modal');
							callback();
						});
					}

					$dialog.modal('hide');
				}
			}
		}
	};

})(jQuery);
